import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { triggerMonetagVignette } from '../utils/monetagVignette';

function Landing() {
    const { user, loading } = useUser();

    useEffect(() => {
        if (loading) return;
        if (user?.hasNoAds) return;
        triggerMonetagVignette('landing');
    }, [loading, user]);

    return (
        <div className="page landing-page">
            <section className="landing-hero">
                <div className="landing-hero__main">
                    <span className="hero-eyebrow">Less scrolling, more cooking</span>
                    <h1 className="hero-title">Recipes that feel ready to cook</h1>
                    <p className="hero-subtitle">
                        RecipeCore removes the noise and gives you clean ingredients, clear steps, and practical tags.
                    </p>
                    <div className="hero-journey" aria-label="Recipe workflow">
                        <span className="hero-journey-step">Paste source</span>
                        <span className="hero-journey-step">Review quickly</span>
                        <span className="hero-journey-step">Save and cook</span>
                    </div>
                    <div className="hero-actions">
                        <Link className="btn btn-primary" to="/login">Launch workspace</Link>
                        <Link className="btn btn-secondary" to="/register">Create free account</Link>
                    </div>
                </div>
                <aside className="landing-hero-note">
                    <h3>Built for everyday cooking</h3>
                    <ul className="hero-list">
                        <li>Drop any recipe URL or raw text.</li>
                        <li>Check what matters in one review step.</li>
                        <li>Keep a personal cookbook that stays organized.</li>
                    </ul>
                </aside>
            </section>

            <section className="page-section">
                <div className="page-header">
                    <span className="page-eyebrow">Why RecipeCore</span>
                    <h2>A practical kitchen workflow</h2>
                    <p className="page-subtitle">
                        Whether you plan weekend meals or cook on the fly, RecipeCore keeps the path from recipe link to stovetop short and calm.
                    </p>
                </div>
                <div className="feature-grid">
                    <article className="feature-card feature-card--primary">
                        <h3 className="feature-card-title">Browser-to-bowl fast</h3>
                        <p>Paste once and get a clean version you can actually use while cooking.</p>
                    </article>
                    <article className="feature-card">
                        <h3 className="feature-card-title">Save what matters</h3>
                        <p>Find recipes later by title or tag without digging through bookmarks.</p>
                    </article>
                    <article className="feature-card">
                        <h3 className="feature-card-title">Cook mode ready</h3>
                        <p>Switch to large-step mode when your hands are busy and timing matters.</p>
                    </article>
                </div>
            </section>
        </div>
    );
}

export default Landing;
